import type { AreaOfInterest } from "verdi-common/schemas/areaOfInterest/areaOfInterest";
import type { AreaOfInterestSchemaTypes } from "../../../verdi-common/src/schemas/types/areaOfInterest.js";
import { SessionHandler } from "./SessionHandler.js";

export class AreaOfInterestAPI {
    /**
     * Gets the information for a single area of interest
     * @param id an area of interest ID
     */
    static async getOne(id: string): Promise<AreaOfInterest> {
        const response = await SessionHandler.doFetch("aoi/" + id, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "GET",
            redirect: "follow",
        });
        return await response.json();
    }

    /**
     * Gets all area of interests
     */
    static async getAll(): Promise<AreaOfInterest[]> {
        const response = await SessionHandler.doFetch("aoi/", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "GET",
            redirect: "follow",
        });
        return await response.json();
    }

    /**
     * Creates a new area of interest
     * @param {Object} properties
     * @return {Promise<{Object}>}
     */
    static async createOne(
        properties: Omit<AreaOfInterestSchemaTypes["create"], "schemaKey">,
    ): Promise<AreaOfInterest> {
        const response = await SessionHandler.doFetch("aoi/", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(properties),
            redirect: "follow",
        });
        return await response.json();
    }

    /**
     * Edits an area of interest
     * @param {string} id
     * @param {Object} properties
     * @return {Promise<{Object}>}
     */
    static async editOne(
        id: string,
        properties: Omit<AreaOfInterestSchemaTypes["update"], "schemaKey">,
    ): Promise<AreaOfInterest> {
        const response = await SessionHandler.doFetch("aoi/" + id, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "PUT",
            body: JSON.stringify(properties),
            redirect: "follow",
        });
        return await response.json();
    }

    /**
     * Deletes an area of interest
     * @param {string} id
     * @return {Promise<{Object}>}
     */
    static async deleteOne(id: string) {
        const response = await SessionHandler.doFetch("aoi/" + id, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "DELETE",
            redirect: "follow",
        });
        return await response.json();
    }
}
